<template>
   <div>
    <div>
        <div class="clearfix table-tools">
        <div class="search">
            <a-form layout='inline' @submit="searchList">
            <a-form-item>
                <a-tooltip placement="topLeft" >
                <template slot="title">
                    <span>时间筛选</span>
                </template>
                <a-range-picker
                    :ranges="rangesData"
                    :value='rangesValue'
                    :disabled-date="disabledDate" :allowClear="false"
                    :default-value="[moment(paramsData.stock_date,'YYYY-MM-DD'),moment(paramsData.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                    @change="(date, dateString)=>onChange(date, dateString,1)" />
                </a-tooltip>
            </a-form-item>

            <a-form-item>
                <a-select
                    v-model="paramsData.stock_code"
                    placeholder="股票代码"
                    style="width: 150px;"
                    allowClear
                    showSearch
                    :filterOption="filterOption"
                >
                    <a-select-option v-for="(stock, key) in stockCodes" :key="key" :value="stock">
                        {{ stock }}
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
            </a-form-item>

            </a-form>
        </div>
        </div>
        <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>

        <div class="table-container">
            <a-table size="small" :bordered='false'
                :columns="columns" :dataSource="list"
                :rowKey="(record, index) => `${record.stock_code}_${record.stock_date}_${record.stock_tm}`"
                :pagination="false">
            <template slot="index" slot-scope="text, record , index">
            <span>{{index + 1}}</span>
            </template>

            <template slot="stock_code" slot-scope="text, record , index">
                <span @click="copyStockCode(text)" style="cursor: pointer; color: #1890ff;">{{text}}</span>
            </template>

            <template slot="stock_name" slot-scope="text, record , index">
                <a-popover :title="text">
                    <template slot="content">
                        <img :src="record.chart_url" alt="" width="900px">
                    </template>
                    <span>{{ text }}</span>
                </a-popover>
            </template>

            <template slot="stock_price" slot-scope="text, record , index">
                <span>{{ formatNumber(text) }}</span>
            </template>

            <template slot="stock_zhangdiefu" slot-scope="text, record , index">
                <span :style="{ color: text > 0 ? 'red' : text < 0 ? 'green' : 'black' }">{{ formatPercent(text) }}</span>
            </template>

            <template slot="stock_vol" slot-scope="text, record , index">
                <span>{{ formatNumber(text) }}</span>
            </template>

            <template slot="stock_total" slot-scope="text, record , index">
                <span>{{ formatMillion(text) }}</span>
            </template>

            <template slot="stock_gap_total" slot-scope="text, record , index">
                <span :style="{ color: text > 0 ? 'red' : text < 0 ? 'green' : 'black' }">{{ formatMillion(text) }}</span>
            </template>

            <template slot="stock_is_max" slot-scope="text, record , index">
                <a-tag :color="text === '1' ? 'red' : 'default'">{{ text === '1' ? '是' : '否' }}</a-tag>
            </template>

            </a-table>
        </div>
        </div>
    </div>
   </div>
</template>

<script>
import moment from 'moment'
import vueElementLoading from 'vue-element-loading'
export default {
    name: 'breakListGrid',
    components: {
        vueElementLoading
    },
    data() {
        return {
            loading: false,
            list: [],
            paramsData: {
                stock_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                stock_code: ''
            },
            stockCodes: [], // 股票代码列表，将从API获取
            rangesData: {
                '今天': [moment(), moment()],
                '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                '最近7天': [moment().subtract(6, 'days'), moment()],
                '最近30天': [moment().subtract(29, 'days'), moment()],
                '本月': [moment().startOf('month'), moment().endOf('month')],
                '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rangesValue: [moment(), moment()],
            columns: [
                { title: '#', width: 50, scopedSlots: { customRender: 'index' } },
                { title: '股票代码', dataIndex: 'stock_code', width: 100, scopedSlots: { customRender: 'stock_code' } },
                { title: '股票名称', dataIndex: 'stock_name', width: 120, scopedSlots: { customRender: 'stock_name' } },
                { title: '日期', dataIndex: 'stock_date', width: 120 },
                { title: '时间', dataIndex: 'stock_tm', width: 80 },
                { title: '价格', dataIndex: 'stock_price', width: 100, scopedSlots: { customRender: 'stock_price' } },
                { title: '涨跌幅', dataIndex: 'stock_zhangdiefu', width: 100, scopedSlots: { customRender: 'stock_zhangdiefu' } },
                { title: '成交量', dataIndex: 'stock_vol', width: 120, scopedSlots: { customRender: 'stock_vol' } },
                { title: '累积成交', dataIndex: 'stock_total', width: 120, scopedSlots: { customRender: 'stock_total' } },
                { title: '突破金额', dataIndex: 'stock_gap_total', width: 120, scopedSlots: { customRender: 'stock_gap_total' } },
                { title: '更新时间', dataIndex: 'stock_update', width: 150 }
            ]
        }
    },
    created() {
        this.getList()
    },
    methods: {
        moment,
        // 获取列表数据
        async getList() {
            this.loading = true
            let res = await this.$store.dispatch('enterpriseLabStockBreakupAction', {data:this.paramsData})
            this.loading = false
            
            if (res && res.data && res.data.breakup_list) {
                this.list = res.data.breakup_list
                
                // 收集股票代码用于筛选
                const codes = new Set()
                this.list.forEach(item => {
                    if (item.stock_code) {
                        codes.add(item.stock_code)
                    }
                })
                this.stockCodes = Array.from(codes).sort()
            } else {
                this.list = []
                this.$message.error('获取数据失败')
            }
        },
        // 搜索
        searchList(e) {
            e.preventDefault()
            this.getList()
        },
        // 日期变化
        onChange(date, dateString, type) {
            this.paramsData.stock_date = dateString[0]
            this.paramsData.end_date = dateString[1]
            this.rangesValue = date
        },
        // 禁用今天之后的日期
        disabledDate(current) {
            return current && current > moment().endOf('day')
        },
        // 复制股票代码
        copyStockCode(stockCode) {
            // 创建一个临时的输入框元素
            const tempInput = document.createElement('input')
            tempInput.value = stockCode
            document.body.appendChild(tempInput)
            tempInput.select()
            
            try {
                // 执行复制命令
                const successful = document.execCommand('copy')
                document.body.removeChild(tempInput)
                
                if (successful) {
                    this.$message.success(`股票代码 ${stockCode} 已复制到剪贴板`)
                } else {
                    this.$message.error('复制失败，请手动复制')
                }
            } catch (err) {
                document.body.removeChild(tempInput)
                this.$message.error('复制失败，请手动复制')
            }
        },
        // 格式化数字
        formatNumber(num) {
            if (num === null || num === undefined) return ''
            return Number(num).toLocaleString()
        },
        // 格式化为百万单位
        formatMillion(num) {
            if (num === null || num === undefined) return ''
            const value = Number(num)
            if (isNaN(value)) return ''
            
            // 如果数值大于等于100万，显示为百万单位
            if (Math.abs(value) >= 1000000) {
                return (value / 1000000).toFixed(2) + 'M'
            }
            // 否则显示原值
            return value.toLocaleString()
        },
        // 格式化为百分比
        formatPercent(num) {
            if (num === null || num === undefined) return ''
            const value = Number(num)
            if (isNaN(value)) return ''
            
            // 如果是整数，直接显示为百分比
            if (Number.isInteger(value)) {
                return value + '%'
            }
            
            // 如果是小数，保留两位小数并显示为百分比
            return value.toFixed(2) + '%'
        },
        // 下拉框搜索过滤方法
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}

.table-container {
  overflow-x: auto; /* 启用水平滚动 */
  width: 100%;
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px; /* 水平滚动条高度 */
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}

/* 确保表格在容器中正确显示 */
.ant-table {
  min-width: 100%;
  
  .ant-table-body {
    overflow-x: auto !important;
  }
}
</style>